<!-- eslint-disable max-len -->
<template>
  <div id="headermain">
    <div class="w-full bg-white header_main">
      <div class="body_inner">
        <div class="flex items-center w-full">
          <div
            class="
              flex
              items-center
              justify-start
              w-1/4
              menu_item menu_btnblock
            "
          >
            <LeftMenu v-if="!hideLeftMenu" />
          </div>
          <div
            class="
              title
              flex
              items-center
              justify-center
              w-2/4
              menu_item
              logo_block
            "
          >
            <img
              class="ml-2 cursor-pointer"
              src="../../assets/images/logo_pflegehelden.png"
              alt=""
              @click="
                () => {
                  if ($route.name !== 'VerifyInvitation') {
                    $router.push({ name: 'offerSearch' });
                  }
                }
              "
            />
          </div>
          <div class="flex items-center justify-end w-1/4 menu_item login_menu">
            <svg
              v-if="['id_check_block'].includes($route.name)"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="$router.push({ name: 'offerSearch' })"
            >
              <path
                d="M16.7433 0.488979C16.5452 0.493656 16.357 0.576509 16.2198 0.719448L9.00012 7.93918L1.78039 0.719448C1.71048 0.647455 1.62684 0.590221 1.53441 0.551137C1.44198 0.512053 1.34265 0.491913 1.2423 0.491909C1.09304 0.491945 0.947187 0.536513 0.823398 0.619909C0.699609 0.703306 0.603515 0.821738 0.547413 0.960054C0.49131 1.09837 0.47775 1.25028 0.508468 1.39635C0.539185 1.54241 0.612782 1.67599 0.719843 1.77999L7.93957 8.99972L0.719843 16.2194C0.647865 16.2886 0.590399 16.3713 0.550812 16.4629C0.511224 16.5545 0.490311 16.6531 0.489297 16.7529C0.488282 16.8527 0.507187 16.9516 0.544904 17.044C0.58262 17.1364 0.638391 17.2203 0.70895 17.2909C0.779508 17.3614 0.863436 17.4172 0.955818 17.4549C1.0482 17.4927 1.14718 17.5116 1.24696 17.5105C1.34674 17.5095 1.44531 17.4886 1.53691 17.449C1.6285 17.4094 1.71128 17.352 1.78039 17.28L9.00012 10.0603L16.2198 17.28C16.2889 17.352 16.3717 17.4094 16.4633 17.449C16.5549 17.4886 16.6535 17.5095 16.7533 17.5105C16.8531 17.5116 16.952 17.4927 17.0444 17.4549C17.1368 17.4172 17.2207 17.3614 17.2913 17.2909C17.3618 17.2203 17.4176 17.1364 17.4553 17.044C17.493 16.9516 17.5119 16.8527 17.5109 16.7529C17.5099 16.6531 17.489 16.5545 17.4494 16.4629C17.4098 16.3713 17.3524 16.2886 17.2804 16.2194L10.0607 8.99972L17.2804 1.77999C17.3895 1.67532 17.4643 1.54012 17.4952 1.39214C17.5261 1.24416 17.5116 1.0903 17.4535 0.950726C17.3955 0.811152 17.2966 0.692381 17.1698 0.609984C17.0431 0.527587 16.8944 0.485408 16.7433 0.488979Z"
                fill="#333333"
              />
            </svg>
            <RightMenu v-if="!hideRightMenu" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import LeftMenu from "@/components/header/actions/Left";
import RightMenu from "@/components/header/actions/Right";

export default {
  name: "Header",
  components: { LeftMenu, RightMenu },
  computed: {
    hideRightMenu() {
      return [
        "ProfileLanding",
        "ProfileEdit",
        "ProfileFAQ",
        "ProfileDocuments",
      ].includes(this.$route.name);
    },
    hideLeftMenu() {
      return [
        "onBoarding",
        "confirmCell",
        "confirmOtp",
        "checkLastname",
        "checkLastnameFailed",
        "otpFail",
      ].includes(this.$route.name);
    },
  },
};
</script>

<style scoped>
/*----------------------- ------------------------ */

.header_main {
  position: relative;
  padding: 0 0;
  height: 56px;
  margin: 0 0 5px;
}
.header_main .menu_item {
  height: 56px;
  padding: 10px 0;
}

.header_main .logo_block img {
  max-width: 100%;
  width: auto;
}

.fixedHeader .header_main {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
svg {
  width: 20px;
  height: 20px;
}
</style>
